import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import editapi from "../api/fourthconvocationbulk";
import loginapi from "../api/login";
import { APISERVERURL } from '../APIServerURL';
import SelectedImages from '../components/SelectedImages'

const ConvocationTable = ({ data = [] }) => {
  // Filter out the structural fallback header row if present in the data array
  const studentRecords = data.filter(
    (item) => item.enrolment_id !== "Enrolment No."
  );

  if (studentRecords.length === 0) {
    return (
      <div className="p-8 text-center text-gray-500 bg-gray-50 rounded-lg border border-gray-200">
        No student records found to display.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border text-sm text-left">
          
          {/* Table Headers: One for each specific field */}
          <thead className="bg-yellow-600 text-xs font-semibold uppercase tracking-wider text-white border-b border-yellow-600">
            <tr>
              <th className="px-6 py-4">Enrolment ID</th>
              <th className="px-6 py-4">Pass Year</th>
              <th className="px-6 py-4">Name</th>
              <th className="px-6 py-4">Assamese Name</th>
              <th className="px-6 py-4">Stream Name</th>
              <th className="px-6 py-4">Semester</th>
              <th className="px-6 py-4">Faculty</th>
              <th className="px-6 py-4">Subject Name</th>
              <th className="px-6 py-4">Convocation Number</th>
              <th className="px-6 py-4">Convocation Year</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="divide-y divide-gray-100 bg-white">
            {studentRecords.map((student, index) => (
              <tr 
                key={student.enrolment_id || index} 
                className="hover:bg-gray-50 transition-colors duration-150"
              >
                {/* 1. enrolment_id */}
                <td className="px-6 py-4 font-semibold text-gray-900">
                  {student.enrolment_id}
                </td>

                {/* 2. passYear */}
                <td className="px-6 py-4 text-gray-700">
                  {student.passYear || 'N/A'}
                </td>

                {/* 3. name */}
                <td className="px-6 py-4 font-medium text-gray-900">
                  {student.name}
                </td>

                {/* 4. assamese_name */}
                <td className="px-6 py-4 text-blue-600 font-serif">
                  {student.assamese_name || '—'}
                </td>

                {/* 5. stream_name */}
                <td className="px-6 py-4 text-gray-700">
                  {student.stream_name}
                </td>

                {/* 6. semester */}
                <td className="px-6 py-4 text-gray-600 text-xs">
                  {student.semester}
                </td>

                {/* 7. faculty */}
                <td className="px-6 py-4 text-gray-600 max-w-xs truncate">
                  {student.faculty || 'N/A'}
                </td>

                {/* 8. subject_name */}
                <td className="px-6 py-4">
                  <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                    {student.subject_name || '—'}
                  </span>
                </td>

                {/* 9. convocation_number */}
                <td className="px-6 py-4 font-medium text-gray-800">
                  {student.convocation_number}
                </td>

                {/* 10. convocation_year */}
                <td className="px-6 py-4 text-gray-700">
                  {student.convocation_year || '—'}
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>
 
  );
};

function FourthConvocation({ accessToken, setAccessToken }) {
  const navigate = useNavigate();

  const [studentList, setStudentList] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
  const [savingId, setSavingId] = useState("");
  // Filters
  const [filterStream, setFilterStream] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [filterEnrolment, setFilterEnrolment] = useState("");

  const convocationOptions = ["First", "Second", "Third", "Fourth", "Fifth"];


// 2. State variable to hold the selected convocation value
const [filterConvocation, setFilterConvocation] = useState("");

const [images,setImages]=useState([]);
    const [uploadStatus, setUploadStatus]=useState(null);
const [isUploading,setIsUploading]=useState(false);
const [isConfirming,setIsConfirming]=useState(false);

const [isConfirmed,setIsConfirmed]=useState("");
const [messages,setMessages]=useState([]);



  const handleGoBack = () => navigate("/");

  const handleSave = async (student) => {
   setSavingId(student.enrolment_id);

  try {
      const response = await editapi.post(
        "/saveConvoStudent",
        {student},
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      alert("SAVED!");
    } catch (err) {
      if (err.response?.status === 403) return navigate("/accessdenied");

      try {
        const config = { withCredentials: true };
        const x = await loginapi.get("/getAccessToken", config);

        const nat = x.data.accessToken;
        setAccessToken(nat);

        const response = await editapi.post(
          "/saveConvoStudent",
          { student },
          { headers: { Authorization: `Bearer ${nat}` } }
        );

        alert("SAVED!");
      } catch (err2) {
        alert("Failed to fetch data");
      }
    } finally {
      setSavingId("");
    }
};


        function downloadFile(fname)
            {
              fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
                response.blob().then((blob) => {
                 
                    // Creating new object of PDF file
                    const fileURL =
                        window.URL.createObjectURL(blob);
                         
                    // Setting various property values
                    let alink = document.createElement("a");
                    alink.href = fileURL;
                    alink.download = fname;
                    alink.click();
                    //setIsloading(false);
                });
              });
            }

 async function downloadCertificates()
            {
              alert(filterStream+" "+filterYear+" "+filterEnrolment);             
              setIsDownloading(true);
              try{
                //session, batch, semester,bg
                const response= await editapi.post('/printSelectedConvoCertificates',{stream:filterStream,year:filterYear,enrolmentid:filterEnrolment,convocationNumber:filterConvocation},{headers:{'Authorization':`Bearer ${accessToken}`}});    
                alert(response.data);
                downloadFile(response.data);
              }
              catch(err)
              {
                try{
                  const config = { withCredentials: true };
                  const x=await loginapi.get('/getAccessToken',config);
                  
                  const nat=x['data']['accessToken'];
                  setAccessToken(nat);
                  try{       
                    const response= await editapi.post('/printSelectedConvoCertificates',{stream:filterStream,year:filterYear,enrolmentid:filterEnrolment,convocationNumber:filterConvocation},{headers:{'Authorization':`Bearer ${nat}`}});    
                    downloadFile(response.data);
                   }
                   catch(err)
                   {
                    alert('unusual error newposts.js');
                   }
                }
                catch(err)
                {
                  alert('failed');
                }
        
              }
              finally
              {
                setIsDownloading(false);
              }
            }



  // ========================= FETCH DATA =============================
  async function getAllRawData() {
    setStudentList([]);
    setIsLoadingData(true);
    setFilterEnrolment('');
    setFilterYear('');
    setFilterStream('');
    
    try {
      const response = await editapi.post(
        "/getRawConvocationdata",
        { convocationNumber: filterConvocation },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      setStudentList(response.data.list);
    } catch (err) {
      if (err.response?.status === 403) return navigate("/accessdenied");

      try {
        const config = { withCredentials: true };
        const x = await loginapi.get("/getAccessToken", config);

        const nat = x.data.accessToken;
        setAccessToken(nat);

        const response = await editapi.post(
          "/getRawConvocationdata",
          { convocationNumber:filterConvocation },
          { headers: { Authorization: `Bearer ${nat}` } }
        );

        setStudentList(response.data.list);
      } catch (err2) {
        alert("Failed to fetch data");
      }
    } finally {
      setIsLoadingData(false);
    }
  }

  useEffect(() => {
    getAllRawData();
  }, [filterConvocation]);

  // ===================== UNIQUE FILTER VALUES =======================
  const uniqueStreams = [...new Set(studentList.map((s) => s.stream_name))];
  const uniqueYears = [...new Set(studentList.map((s) => s.passYear))];

  // ===================== FILTERED DATA ===============================
  const filteredList = studentList.filter((s) => {
    return (
      (filterStream === "" || s.stream_name === filterStream) &&
      (filterYear === "" || s.passYear === filterYear) &&

      // NEW: Enrolment ID live search
      (filterEnrolment === "" ||
        s.enrolment_id.toLowerCase().includes(filterEnrolment.toLowerCase()))
    );
  });

  // ===================== FIELD UPDATE ===============================
  const updateField = (index, field, value) => {
    const temp = [...studentList];
    temp[index][field] = value;
    setStudentList(temp);
  };

function addToImageList(selectedFiles)
  {
      const newImages=[...selectedFiles];
      setImages(newImages);
        setUploadStatus(null);
        setIsConfirmed("");
  }

    const cancelUpload=(e)=>{
      setUploadStatus(null);
    }
    
    const handleAddNew=async (e)=>
        {
           e.preventDefault();
           setUploadStatus(null);
           setIsUploading(true);
           
            let formData = new FormData();    //formdata object
            
            
      
            Object.values(images).forEach(file=>{
              formData.append("images", file);
            });
            const config = {     
                headers: { 'content-type': 'multipart/form-data' }
            }
      
          
           //call api to save the form  
  
           
            try{
            const response= await editapi.post('/uploadConvoData',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
            //setRegistrationForm(response.data.registrationForm);
            //alert(JSON.stringify(response.data));
             setUploadStatus(response.data);
            setImages([]);
            }
            catch(err)
            {
                try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);
                //alert(JSON.stringify(x['data']['accessToken']));
                
                const nat=x['data']['accessToken'];
                setAccessToken(nat);
                //console.log(`ne at ${nat}`);
                //console.log(`Second at:${accessToken}`);
                try{       
                    const response= await editapi.post('/uploadConvoData',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                   // setRegistrationForm(response.data.registrationForm); 
                       //alert(JSON.stringify(response.data));
                       setUploadStatus(response.data);
                    setImages([]);
                }
                catch(err)
                {
                    alert('unusual error newposts.js');
                   
                    //navigate('/');
                }
                }
                catch(err)
                {
                alert('failed');
               
                //setError(JSON.stringify(err));
                //navigate('/');
                }
  
            }
            finally
            {
               setIsUploading(false);
            }
          }
  
    const confirmUpload=async(e)=>{
            try{      
          setIsConfirming(true); 
          setIsConfirmed("");
          //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
          const response=await editapi.post('/confirmUploadConvocationData',{uploadStatus},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
          //alert(JSON.stringify(response.data));
          //setCourses(response.data.courseDetails); 
          //alert(response.data);
          setMessages(response.data.messages);
          }
          catch(err)
          {
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);            
              const nat=x['data']['accessToken'];
              const lt=x['data']['loginType'];
              //alert(nat);
              setAccessToken(nat);
              //setRefreshFailed(false);  
                      
             
                if(lt.toLowerCase()==="admin")
                  {
                        try{       
                          //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                          const response=await editapi.post('/confirmUploadConvocationData',{uploadStatus},{headers:{'Authorization':`Bearer ${nat}`}});                       
                          //alert(JSON.stringify(response.data));
                          ///setCourses(response.data.courseDetails); 
                          //alert(response.data);
                          setMessages(response.data.messages);
                      }
                      catch(err)
                      {
                        //alert('refresh failed unusual'+JSON.stringify(err));
                        setAccessToken('');
                       // setRefreshFailed(true);  
                      }
                    }
              }
              catch(err)
              {
                //alert('dd');
                setAccessToken(''); 
                //setRefreshFailed(true);              
              }
          }         
           finally
              {
                setIsConfirming(false);
                setUploadStatus(null);
                setIsConfirmed("UPLOADED SUCCESSFULLY.");
                await getAllRawData();
                //alert('app loaded'+accessToken);
              }
          }

  // ============================ UI ===================================
  return (
    <main className="w-full">
      <div className="flex flex-col items-center w-full">
        {/* Header */}
        <div className="w-full bg-red-100 relative py-1">
          <button
            onClick={handleGoBack}
            className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs"
          >
            BACK
          </button>

          <h1 className="text-2xl text-gray-400 text-center">
            Convocation Data
          </h1>
          <p className="w-full text-center font-semibold text-xs text-transparent">
            (The form is autosave)
          </p>
        </div>


{true && (<div className="w-full flex flex-col justify-center items-center gap-1 bg-blue-100 mb-4 p-4">
  <form className='w-[98%] max-w-[600px] ' onSubmit={handleAddNew}>
<div className="w-full flex flex-col justify-center items-center">
  <p className="text-center p-1 m-1">
    Upload convocation CSV file in prescribed format
  </p>
 <a
  href="/PrescribedConvoFormat.csv"
  download
  className="inline-block m-3 px-4 py-2 text-blue-700 rounded hover:text-blue-900 transition-colors duration-200"
>
  download prescribed CSV file to see the format
</a>


</div>
 <div className="flex flex-col justify-center items-center w-full  max-w-[600px] w-[99%] mb-2 ">
          <label
  htmlFor="fuPhotos"
  className="text-center inline-block px-4 py-2 bg-blue-600 text-white rounded cursor-pointer hover:bg-blue-700 transition"
>
  Select CSV to Upload
</label>
<input
  type="file"
  id="fuPhotos"
  name="uploadedPhotos"
  accept=".csv"
  style={{ display: 'none' }}
  onClick={(e) => {
    e.target.value = null; // 👈 reset input so same file can be selected again
  }}
  onChange={(e) => {
    addToImageList(e.target.files);
  }}
/>

</div>

<div className="max-w-[600px] w-[99%] p-3  mt-2 mb-2">
            <SelectedImages
            images={images}
            setImages={setImages}
            >
            </SelectedImages>
            </div>

  {true &&(<div className="w-full flex flex-col justify-center items-center">
    <button
          type="submit"
          className="inline-block px-4 py-2 bg-green-600 text-white rounded cursor-pointer hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isUploading  || images.length === 0}
         >
          {isUploading ? "PLEASE WAIT..." : "UPLOAD"}
    </button>
  </div>)}
    </form>
   
    {uploadStatus && uploadStatus.content && (<div className="w-full bg-yellow-100 p-3">
      <p className="text-center m-2 p-1">Following data will be saved in the database</p>
     
      {<ConvocationTable data={uploadStatus.content} />}
    <div className="flex justify-between p-1 text-xs m-2">
      <button
      onClick={cancelUpload}
    className="inline-block px-4 py-2 bg-red-600 text-white rounded cursor-pointer hover:bg-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
  >
    CANCEL
  </button>
  <button
    onClick={confirmUpload}
  
    className="inline-block px-4 py-2 bg-green-600 text-white rounded cursor-pointer hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
  >
    CONFIRM
  </button>
  
</div>

    </div>)}

    
     <div className="flex justify-between p-1 text-xs m-2">
  {isConfirmed === "UPLOADED SUCCESSFULLY." && (
    <div className="flex flex-col">
      {messages.map((msg, index) => (
        <p key={index}>{msg}</p>
      ))}
    </div>
  )}
</div>
</div>)}



       {isLoadingData && (<p className="text-center">Please wait....</p>)}

       {!isLoadingData &&
       (
        <>
        {/* Convocation Number Filter */}
        <div className="w-full p-2 bg-blue-100 flex items-center justify-center mt-1">
<div >
  <label className="font-semibold text-sm">Convocation</label>
  <select
    value={filterConvocation}
    onChange={(e) => setFilterConvocation(e.target.value)}
    className="border p-1 ml-2 rounded"
  >
    <option value="">Select Convo Number</option>
    {convocationOptions.map((option, i) => (
      <option key={i} value={option}>
        {option}
      </option>
    ))}
  </select>
</div>
</div>
        {/* Filters */}
        <div className="w-full mt-4 px-4">
          <div className="bg-gray-100 p-3 rounded-lg shadow flex flex-wrap gap-4 items-center justify-center">

         {/* Enrolment ID Filter */}
            <div>
              <label className="font-semibold text-sm">Enrolment ID</label>
              <input
                type="text"
                value={filterEnrolment}
                onChange={(e) => setFilterEnrolment(e.target.value)}
                placeholder="Type enrolment…"
                className="border p-1 ml-2 rounded"
              />
            </div>
            {/* Stream Filter */}
            <div>
              <label className="font-semibold text-sm">Stream</label>
              <select
                value={filterStream}
                onChange={(e) => setFilterStream(e.target.value)}
                className="border p-1 ml-2 rounded"
              >
                <option value="">All</option>
                {uniqueStreams.map((s, i) => (
                  <option key={i} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>

            {/* Year Filter */}
            <div>
              <label className="font-semibold text-sm">Pass Year</label>
              <select
                value={filterYear}
                onChange={(e) => setFilterYear(e.target.value)}
                className="border p-1 ml-2 rounded"
              >
                <option value="">All</option>
                {uniqueYears.map((y, i) => (
                  <option key={i} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
            

            
          </div>
          <div className="w-full flex flex-col justify-center items-center mt-2">
            <div className="w-full flex justify-center ">
              <label>Match count <label className="text-5xl">{filteredList.length}</label></label>
              </div>
            <button
  className={
    "bg-blue-500 text-white px-3 py-2 mt-2 mb-2 rounded text-xs " +
    (isDownloading ? "opacity-60 cursor-not-allowed" : "hover:bg-blue-600")
  }
  onClick={() => {
    if (!isDownloading) downloadCertificates();
  }}
  disabled={isDownloading}
>
  {isDownloading ? "Downloading…" : "PRINT CERTIFICATES"}
</button>
          </div>
        </div>

        {/* Table */}
        <div className="w-full mt-4 px-2">
          <table className="w-full border border-gray-300 rounded-lg">
            <thead className="bg-gray-100">
              <tr>
                <th className="border p-2 text-xs">Enrolment ID</th>
                <th className="border p-2 text-xs">Stream</th>
                <th className="border p-2 text-xs">Pass Year</th>
                <th className="border p-2 text-xs">Name</th>
                <th className="border p-2 text-xs">Assamese Name</th>
                <th className="border p-2 text-xs">Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredList.length === 0 && (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center p-4 text-gray-400 text-sm"
                  >
                    No records found
                  </td>
                </tr>
              )}

              {filteredList.map((stu, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="border p-2 text-xs">{stu.enrolment_id}</td>
                  <td className="border p-2 text-xs">{stu.stream_name}</td>
                  <td className="border p-2 text-xs">{stu.passYear}</td>

                  {/* Editable Name */}
                  <td className="border p-2 text-xs">
                    <input
                      type="text"
                      value={stu.name}
                      onChange={(e) =>
                        updateField(studentList.indexOf(stu), "name", e.target.value)
                      }
                      className="w-full px-2 py-1 border rounded"
                    />
                  </td>

                  {/* Editable Assamese Name */}
                  <td className="border p-2 text-xs">
                    <input
                      type="text"
                      value={stu.assamese_name}
                      onChange={(e) =>
                        updateField(studentList.indexOf(stu), "assamese_name", e.target.value)
                      }
                      className="w-full px-2 py-1 border rounded"
                    />
                  </td>

                  {/* Save Button */}
                  <td className="border p-2 text-xs text-center">
                    <button
  disabled={savingId === stu.enrolment_id}
  onClick={() => handleSave(stu)}
  className="min-w-[100px] bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 text-xs"
>
  {savingId === stu.enrolment_id ? "Saving..." : "SAVE"}
</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div></>
)}
        
      </div>
    </main>
  );
}

export default FourthConvocation;
